module.exports = __webpack_public_path__ + "static/img/img(19).cb05a75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(19).png
// module id = cxop
// module chunks = 1